import { Mapper } from "../domain/mappers/Mapper";
import { AddressDTO, AddressForm } from "../domain/models/dto/AddressDTO";
import { SimpleMapper } from "./SimpleMapper";

class AddressMapperImpl extends SimpleMapper<AddressForm, AddressDTO> {
    protected toDTOFields: string[] = ["id", "country", "city", "address"];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "parentId",
        "parentType",
        "createdAt",
        "updatedAt",
    ];
}

export default function addressMapperFactory(): Mapper<
    AddressForm,
    AddressDTO
> {
    return new AddressMapperImpl();
}
